// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/academy/:id\",\"regex\":\"^/academy/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/ai-assistant/:id\",\"regex\":\"^/ai-assistant/([^/]+)$\",\"paramNames\":[\"id\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/academy\"},{\"path\":\"/account\"},{\"path\":\"/account/mange-plan\"},{\"path\":\"/ai-assistant\"},{\"path\":\"/courses\"},{\"path\":\"/live\"},{\"path\":\"/login\"},{\"path\":\"/account/cancel\"},{\"path\":\"/cancellation\"},{\"path\":\"/landing\"}]}";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://c17c34d495736a387935980474f32e2f@o1356865.ingest.us.sentry.io/4509756647997440',

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
